import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function FormField({ id, label, className = "", ...props }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      <Label htmlFor={id} className="text-xs font-semibold text-slate-600">{label}</Label>
      <Input id={id} data-testid={`input-${id}`} className="h-11 bg-white" {...props} />
    </div>
  );
}

export function OptionCard({ checked, onClick, title, subtitle, icon: Icon, testId, disabled }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} data-testid={testId}
      className={`flex w-full items-start gap-3 rounded-md border-2 p-4 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${checked ? "border-[#0099DD] bg-sky-50" : "border-slate-200 bg-white hover:border-slate-300"}`}>
      <Icon className={`mt-0.5 h-5 w-5 ${checked ? "text-[#0099DD]" : "text-slate-400"}`} />
      <span>
        <span className="block font-semibold text-slate-900">{title}</span>
        <span className="block text-xs text-slate-500">{subtitle}</span>
      </span>
    </button>
  );
}
